<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <h2>员工应发</h2>
      <p>成交确认与调整单自动形成应发，可在发放记录中分次支付</p>
    </div>
    <el-card shadow="never">
      <el-form inline>
        <el-form-item label="状态">
          <el-select
            v-model="status"
            clearable
            @change="load"
          >
            <el-option
              label="待发"
              value="OPEN"
            />
            <el-option
              label="已结清"
              value="PAID"
            />
            <el-option
              label="已作废"
              value="VOID"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        :data="rows"
      >
        <el-table-column
          prop="user_name"
          label="员工"
        />
        <el-table-column
          prop="type"
          label="应发类型"
        >
          <template #default="{ row }">
            {{ types[row.type] || row.type }}
          </template>
        </el-table-column>
        <el-table-column
          prop="transaction_id"
          label="成交编号"
        />
        <el-table-column label="应发">
          <template #default="{ row }">¥ {{ money(row.amount) }}</template>
        </el-table-column>
        <el-table-column label="已发">
          <template #default="{ row }">¥ {{ money(row.paid_amount) }}</template>
        </el-table-column>
        <el-table-column label="未发">
          <template #default="{ row }">
            ¥ {{ money(row.remaining_amount) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
        >
          <template #default="{ row }">
            <StatusTag :status="row.status" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-model:current-page="page"
        :total="total"
        :page-size="20"
        layout="total,prev,pager,next"
        @current-change="load"
      />
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { ledgerApi } from '../api'
import StatusTag from '../components/StatusTag.vue'
const rows = ref([]),
  loading = ref(false),
  status = ref('OPEN'),
  page = ref(1),
  total = ref(0),
  types = {
    PERSONAL_COMMISSION: '个人佣金',
    LEADER_BONUS: '组长奖金',
    ADJUSTMENT: '佣金调整',
    REVERSAL: '冲销',
  }
const money = (v) => Number(v || 0).toFixed(2)
const load = async () => {
  loading.value = true
  try {
    const d = await ledgerApi.payables({
      page: page.value,
      pageSize: 20,
      status: status.value,
    })
    rows.value = d.items || []
    total.value = d.total || 0
  } finally {
    loading.value = false
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
.el-pagination {
  justify-content: flex-end;
  margin-top: 18px;
}
</style>
